import systemIdForDomain from '@assets/json/gtm-system-id-for-domain.json';

type SystemId = {
  [key: string]: string;
};

export const getSystemIdByDomain = (domain: string): string => {
  const systemIds: SystemId = systemIdForDomain;
  return systemIds[domain as keyof typeof systemIds];
};
